<template>
<div class="detailsTalk">
  <div class="main-con">
    <div class="details" :style="{height: newlist.length > 8 ? '100%': '100vh'}">
      <breadcrumb :data="['客户中心', this.$route.query.customerName]"></breadcrumb>
      <div class="list-con">
        <div class="top_header">
          <div class="title_tab">全部项目</div>
          <!--        查询-->
          <div class="search_div">

            <div>
              <el-date-picker
                v-model="timeDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="medium "
              >
              </el-date-picker>
            </div>
            <div class="input_div">
              <el-input
                v-model="projectName"
                @change="getList"
                placeholder="搜索项目名称"
                type="text"
                size="medium"
              />
            </div>
            <div>
              <el-button type="danger" @click="getList" icon="el-icon-search" size="medium">搜索</el-button>
              <el-button @click="getDelete" icon="el-icon-delete" size="medium">清空</el-button>
            </div>
          </div>
        </div>
        <div class="list">
          <div
            class="item"
            :key="'list_item_' + index"
            v-for="(item, index) in newlist"
          >
            <div
              class="img"
              @click="golink(item.id)"></div>
            <div class="info">
              <div class="title" @click="golink(item.id)">{{ item.projectName }}</div>
              <div class="desc">
                <div class="user">{{ item.customerName }}</div>
                <div style="display: flex;justify-content: space-between">
                  <div class="time">创建于&nbsp;{{item.createTime | dateFormatter}}</div>
                  <div @click="goDelete(item.id)" v-show="item.associatedProjectsNum === 0" style="cursor: pointer">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
        <div>
          <div v-if="newlist.length===0" class="loading">暂无更多数据</div>
          <div v-else class="loading">已经到达最底部</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Breadcrumb from "@/components/pc/Breadcrumb";
import {getdetailsList, deleteId} from '@/api/customManage'
import moment from "moment";
import {detailsDelete} from "@/api/projectManage";
export default {
  name: "detailsTalk",
  components: {
    Breadcrumb,
  },
  data() {
    return{
      newlist: [],
      timeDate: [],
      strTime: '',
      endTime: '',
      projectName: ''
    }
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
  methods: {
    // 删除
    goDelete(id){
      this.$confirm('此操作将永久删除该项目信息及项目相关文档，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteId(id).then(res => {
          if(res.code === 200){
            this.$message.success('删除成功')
            this.getList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 清空
    getDelete() {
      this.timeDate = []
      this.projectName = ''
      this.getList()
    },
    getTimeNum(value){
      var data = new Date(value)
      var y = data.getFullYear()
      var m = data.getMonth()+1;
      var d = data.getDate();
      var h = data.getHours();
      var i = data.getMinutes();
      var s = data.getSeconds();
      if(m<10){
        m = '0'+ m
      }
      if(h<10){
        h = '0'+h
      }
      if(d<10){
        d = '0'+d
      }
      if(i<10){
        i = '0'+i
      }
      if(s<10){
        s = '0'+s
      }
      return y+'-'+m+'-'+d+' '+h+':'+i+':'+s
    },
    // 点击项目跳转
    golink(id){
      this.$router.push({
        path: '/manage/doclist',
        query: {
          id: id
        }
      })
    },
    getList(){
      var customerName = this.$route.query.customerName
      if(this.timeDate.length){
        console.log(123)
        this.strTime = this.getTimeNum(this.timeDate[0])
        this.endTime = this.getTimeNum(this.timeDate[1])
      }else{
        this.strTime = ''
        this.endTime = ''
      }
      const data = {
        customerName: customerName,
        strTime: this.strTime,
        endTime: this.endTime,
        projectName: this.projectName
      }
      getdetailsList(data).then( res => {
        this.newlist = res.data
      })
    }
  },
  mounted() {
    this.getList()
  }
}
</script>

<style scoped lang="less">
.top_header{
  display: flex;
  justify-content: space-between;
  margin-left: 30px;
}
.search_div{
  display: flex;
  justify-content: space-between;
  margin-right: 30px;
}
.input_div{
  margin: 0px 20px;
}
.list-con {
  margin-top: 16px;
  box-sizing: border-box;
  min-width: 1000px;
}
::v-deep .el-breadcrumb__inner{
  color: rgba(0, 0, 0, 0.85) !important;
}
.loading {
  text-align: center;
  padding: 40px 0;
  color: #b2afaf;
}
.bread-con{
  border-bottom: 1px solid  rgba(0,0,0,0.06);
}
.title_tab{
  font-size: 20px;
  font-weight: bold;
  color: rgba(0,0,0,0.85);
  line-height: 28px;
  margin-right: 30px;
}
.list {
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  & > .item {
    margin-left: 28px;
    flex: 0 0 3.41rem;
    margin-bottom: 0.5rem;
    cursor: pointer;
    & > .img {
      height: 2.31rem;
      border-radius: 0.12rem;
      background-color: #ccc;
      //border: 1px solid #eee;
      box-sizing: border-box;
       background: url('~@/assets/pic_business_normal_300@2x.png') no-repeat center
         center / 100% auto;
      &.add {
        background: url('~@/assets/imgs/add-circle-fill@2x.png') no-repeat
        center center / 56px auto;
        background-color: #f0f0f0;
      }
    }

    & > .info {
      & > .title {
        padding-top: 0.12rem;
        color: rgba(0, 0, 0, 0.85);
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        font-weight: bold;
      }
      & > .desc {
        color: rgba(0, 0, 0, 0.45);
        align-items: center;
        height: 0.2rem;
        padding-top: 0.04rem;

        & > .user {
          flex: 0 0 auto;
          color: black;
        }
        & > .time {
          padding-top: 0.04rem;
          flex: 0 0 auto;
        }
      }
    }
  }
}
.detailsTalk {
  height: 100%;
  background-color: #F4F4F5;
  & > .main-con {
    padding: 16px 0px;
    width: 15.04rem;
    margin: 0 auto;
    min-width: 1000px;
  }
}
.details{
  //height: 100vh;
  width: 100%;
  background-color: #fff;
}
</style>
